import dayjs from "dayjs";
import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  TransferRead,
  TransferService,
  TransferQueryParams,
  TransferCategory,
} from "@/domains/transfer";
import { RootState } from "@/stores";
import { DateRange } from "@/domains/common";

interface TenantSelfDepositState {
  loading: boolean;
  dateRange: DateRange;
  queryParams: TransferQueryParams;
  transfers: TransferRead[];
}

const initialState: TenantSelfDepositState = {
  loading: false,
  dateRange: DateRange.day0,
  queryParams: {
    created_started_at: dayjs().startOf("day").toISOString(),
    created_stopped_at: dayjs().endOf("day").toISOString(),
  },
  transfers: [],
};

export const tenantSelfDepositSelects = {
  loading: (state: RootState) => state.tenantSelfDeposit.loading,
  dateRange: (state: RootState) => state.tenantSelfDeposit.dateRange,
  queryParams: (state: RootState) => state.tenantSelfDeposit.queryParams,
  transfers: (state: RootState) => state.tenantSelfDeposit.transfers,
};

export const tenantSelfDepositThunks = {
  list: createAsyncThunk(
    "tenantSelfDeposit/list",
    async (params: TransferQueryParams = {}) => {
      const res = await TransferService.list({
        ...params,
        category: TransferCategory.TenantDeposit,
      }).run();

      return res.data.msg;
    }
  ),
};

export const tenantSelfDepositSlice = createSlice({
  name: "tenantSelfDeposit",
  initialState,
  reducers: {
    setQueryParams: (state, action: PayloadAction<TransferQueryParams>) => {
      state.queryParams = action.payload;
    },
    setDateRange: (state, action: PayloadAction<DateRange>) => {
      state.dateRange = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(tenantSelfDepositThunks.list.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(tenantSelfDepositThunks.list.fulfilled, (state, action) => {
      state.loading = false;
      state.transfers = action.payload.transfers;
    });
    builder.addCase(tenantSelfDepositThunks.list.rejected, (state) => {
      state.loading = false;
      state.transfers = [];
    });
  },
});

export const tenantSelfDepositActions = tenantSelfDepositSlice.actions;
